// extracted by mini-css-extract-plugin
export var labelWrapper = "_ia-0";